import { useEffect, useState } from "react";

const useStickyNav = (heroRef) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = heroRef?.current?.offsetHeight || 0;
      setIsSticky(window.scrollY > heroHeight);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [heroRef]);

  return isSticky;
};

export default useStickyNav;
